import { useDispatch } from 'react-redux';

import { setShowSignIn, setShowSignUp } from '../../../../store/user';
import { useHomePageTag } from '../../../../tag-manager/homepage';
import { ProfileIcon } from '../../../styles';
import { AuthButton, AuthIconButton, Divider, MenuWrapper } from './styles';

export default function LoggedOutMenu() {
  const dispatch = useDispatch();

  return (
    <MenuWrapper>
      <AuthIconButton
        onClick={() => {
          dispatch(setShowSignIn());
        }}
      >
        <ProfileIcon />
      </AuthIconButton>
      <AuthButton
        onClick={() => {
          useHomePageTag({ label: 'Sign In Button' });
          dispatch(setShowSignIn());
        }}
      >
        <span>Sign In</span>
      </AuthButton>
      <Divider />
      <AuthButton
        onClick={() => {
          useHomePageTag({ label: 'Sign Up Button' });
          dispatch(setShowSignUp());
        }}
      >
        <span>Sign Up</span>
      </AuthButton>
    </MenuWrapper>
  );
}
